//  <FileHeader xmlns="http://www.gordic.cz/shared/file-header/v_1.0.0.0">
//    <Name>        Gordic.Adm.WebControls.DialogsTraProUdalost.ts						</Name>
//    <Description> Funkce pro otev�en� dialog� spojen�ch s Ud�lost </Description>
//    <Author>      JKLUSACEK													</Author>
//    <Copyright>   � GORDIC spol. s r. o. 1993-2021                            </Copyright>
//    <Created>     2021-09-14                      </Created>
//  </FileHeader>

//This source code was auto-generated by ADT03-Generator, Version=486.16.5
//AdtGeneratorConfig:[ T:(ginsevn) GID:(Web.Dia.Ts) V1:(evn_por_cislo,log_por_cislo,iud_por_od,iud_por_do,dat_evn,ktg_evn,typ_evn,res_evn,proces_id,proces_txt,typ_subj,sxs_subj,tab_name,proces_src,klas_evn,ixs_aus,priz_zobr,zmenu_prov) V2:() K1:() K2:() K3:() ]

namespace Gordic.Adm.Dialogs {

    // TraProUdalost
    export function DetailTraProUdalostDlg(
        parentContent: GContent,
        opt: {
            /** evn_por_cislo */
            evn_por_cislo: number | null,
            /** grid jquery element */
            grid?: JQuery<HTMLElement>,
            /** p��znak nov�ho z�znamu */
            newRecord?: boolean
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {
       
    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;
    var detailCommand = opt.grid ? false : true;

    // grid remote control, kv�li �ipk�m na detailu
    const gridRemoteControl = opt && opt.grid ? new Gordic.Components.GridRC(opt.grid) : undefined;

    var detail = ['Gordic.Adm.WebControls.DetailTraProUdalost', { gridRemoteControl: gridRemoteControl }]

    const options = {
        ID: "AdmTraProUdalost#",
        evn_por_cislo: opt ? opt.evn_por_cislo : undefined,
        newRecord: opt ? opt.newRecord : undefined,
        detailCommand: detailCommand
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
}

    // TraProUdalost
    export function SeznamTraProUdalostDlg(
        parentContent: GContent,
        opt: {
            /** evn_por_cislo */
            evn_por_cislo: number | null,
        },
        ModOtevreni?: Gordic.Gin.Globals.Enums.ModOtevreni
    ): JQueryPromise<undefined> {

    const deferred = $.Deferred();
    const pContent = Gordic.Gin.Globals.Dialogs.ZkontrolujContent(parentContent);
    ModOtevreni = Gordic.Gin.Globals.Dialogs.UpravModOtevrni(pContent, ModOtevreni);

    let isValid = true;

    var detail = ['Gordic.Adm.WebControls.SeznamTraProUdalost', { }]

    const options = {
        ID: "AdmTraProUdalost#",
        evn_por_cislo: opt ? opt.evn_por_cislo : undefined,
    };

    if (isValid) {
        //RC 32131033 : Detail
        Gordic.Gui.Dialogs._openDialog(pContent, deferred, detail, ModOtevreni, options);
    } else {
        deferred.reject();
    }
    return deferred.promise();
  }

}
